<script>
import useTools from "@/use/Tools";
import useSharedData from "@/use/SharedData";
import {computed, onMounted, onUnmounted, ref} from "vue";
import {useSecurityStore} from "@/stores/Security";
import {storeToRefs} from "pinia";
import axios from "axios";

export default {
    name: "NotificationAppBar",
    setup() {
        const {$router} = useTools();
        const {loading} = useSharedData();
        const items = ref([]);
        const securityStore = useSecurityStore();
        const {idControlProgram, snackbar, itemsToBeValidate, selectedModule} = storeToRefs(securityStore);


        let total = 0;
        const totalAbsenceValidation = ref(0);
        const totalVacationValidation = ref(0);
        const totalClaimValidation = ref(0);
        const totalAdminRequestValidation = ref(0);
        const totalDebtValidation = ref(0);
        const totalPayDayAdvanceValidation = ref(0);
        const totalRecruitmentRequestValidation = ref(0);
        const totalTrainingRequestValidation = ref(0);
        const totalPaySlipAnnexValidation = ref(0);

        const availableModules = computed(() => {
            const modules = []
            if (securityStore.authorities['READ_WORKER']) modules.push('worker')
            if (securityStore.authorities['READ_CONTRAT']) modules.push('contrat')
            return modules
        })

        function findAll() {
            loading.value = true;
            axios.get('/notificationRecords').then(response => {
                if (availableModules.value.length > 0) {
                    items.value = response.data.elements;
                    checkNew(response.data.total,
                        response.data.totalAbsenceValidation,
                        response.data.totalVacationValidation,
                        response.data.totalClaimValidation,
                        response.data.totalAdminRequestValidation,
                        response.data.totalDebtValidation,
                        response.data.totalPayDayAdvanceValidation,
                        response.data.totalRecruitmentRequestValidation,
                        response.data.totalTrainingRequestValidation,
                        response.data.totalPaySlipAnnexValidation);

                    totalAbsenceValidation.value = response.data.totalAbsenceValidation;
                    totalVacationValidation.value = response.data.totalVacationValidation;
                    totalClaimValidation.value = response.data.totalClaimValidation;
                    totalAdminRequestValidation.value = response.data.totalAdminRequestValidation;
                    totalDebtValidation.value = response.data.totalDebtValidation;
                    totalPayDayAdvanceValidation.value = response.data.totalPayDayAdvanceValidation;
                    totalRecruitmentRequestValidation.value = response.data.totalRecruitmentRequestValidation;
                    totalTrainingRequestValidation.value = response.data.totalTrainingRequestValidation;
                    totalPaySlipAnnexValidation.value = response.data.totalPaySlipAnnexValidation;
                    total = response.data.total;

                }
            }).finally(() => {
                loading.value = false;
            });
        }

        function checkNew(t, tav, tvv, tcv, tadv, tdb, tpda, trq, ttr, tpsa) {
            if (t > total ||
                tav > totalAbsenceValidation.value ||
                tvv > totalVacationValidation.value ||
                tcv > totalClaimValidation.value ||
                tadv > totalAdminRequestValidation.value ||
                tdb > totalDebtValidation.value ||
                tpda > totalPayDayAdvanceValidation.value ||
                trq > totalRecruitmentRequestValidation ||
                ttr > totalTrainingRequestValidation ||
                tpsa > totalPaySlipAnnexValidation) {
                snackbar.value = true;
            }
        }

        const purgeLoading = ref(false);

        function purgeAndAddNewNotificationRecord() {
            purgeLoading.value = true;
            axios.put('/alarms/purgeAndAddNewNotificationRecord').then(() => {
                findAll();
            }).finally(() => {
                purgeLoading.value = false;
            });
        }

        function selectProgram(item) {
            let route;
            switch (item.module) {
                case 'worker':
                    route = 'workers';
                    break;
                case 'contrat':
                    route = 'contrats';
                    break;
            }
            $router.push({name: route}).catch(() => {
            });

            securityStore.setSelectedModule(item.module);

            securityStore.setItemsToBeValidate(false);
            // securityStore.setIssue(null);
            securityStore.setControlProgram(item.idControlProgram);


        }

        function goToValidation(module) {
            let route;
            switch (module) {
                case 'trainingRequest':
                    route = 'training_plans';
                    break;
                case 'recruitmentRequest':
                    route = 'recruitment_requests';
                    break;
                case 'absenceRequest':
                    route = 'absence_requests';
                    break;
                case 'vacation':
                    route = 'vacations';
                    break;
                case 'claim':
                    route = 'claims';
                    break;
                case 'adminRequest':
                    route = 'admin_requests';
                    break;
                case 'debt':
                    route = 'debts';
                    break;
                case 'payDayAdvance':
                    route = 'pay_day_advances';
                    break;
                case 'paySlipAnnex':
                    route = 'pay_slip_annexes';
                    break;

            }


            $router.push({name: route}).catch(() => {
            });

            securityStore.setSelectedModule(module);
            securityStore.setControlProgram(null, null);
            securityStore.setControlProgram(null, null);

            securityStore.setItemsToBeValidate(true);
        }

        let timerId = null;

        const startPolling = () => {
            timerId = setInterval(() => {
                findAll();
            }, 10000);
        };

        const stopPolling = () => {
            if (timerId) {
                clearInterval(timerId);
                timerId = null;
            }
        };

        onMounted(() => {
            startPolling();
        });

        onUnmounted(() => {
            stopPolling();
        });

        return {
            securityStore,
            loading,
            snackbar,
            purgeLoading,
            items,
            idControlProgram,
            itemsToBeValidate,
            selectedModule,
            availableModules,
            totalRecruitmentRequestValidation,
            totalAbsenceValidation,
            totalVacationValidation,
            totalClaimValidation,
            totalAdminRequestValidation,
            totalDebtValidation,
            totalPayDayAdvanceValidation,
            totalTrainingRequestValidation,
            totalPaySlipAnnexValidation,
            findAll,
            purgeAndAddNewNotificationRecord,
            selectProgram,
            goToValidation,
        }
    }
}
</script>

<template>
    <div>
        <v-menu
            offset-y
            :close-on-content-click="true"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    color="amber darken-3"
                    icon
                    @click="findAll"
                    v-bind="attrs"
                    v-on="on"
                >

                    <v-badge
                        v-if="items.length > 0"
                        bottom
                        color="red"
                        dot
                        offset-x="10"
                        offset-y="10"
                    >
                        <v-icon>mdi-bell</v-icon>
                    </v-badge>
                    <v-icon v-else color="amber darken-3">mdi-bell</v-icon>
                </v-btn>
            </template>

            <v-card width="400">
                <v-toolbar dense dark color="orange">
                    <v-btn icon>
                        <v-icon>mdi-bell</v-icon>
                    </v-btn>

                    <v-toolbar-title>Notifications</v-toolbar-title>

                    <v-progress-linear
                        :active="loading"
                        :indeterminate="loading"
                        absolute
                        bottom
                        color="blue"
                    />

                    <v-spacer/>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                :loading="purgeLoading"
                                icon
                                @click="purgeAndAddNewNotificationRecord"
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon>mdi-reload-alert</v-icon>
                            </v-btn>
                        </template>
                        <span>Actualiser</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text class="ml-n4 mt-n4">
                    <v-container fluid>
                        <template v-for="(m, index) in availableModules">
                            <v-list dense :key="`m-${index}`">
                                <v-subheader>
                                    <strong class="blue--text">{{ $t(`alarm.${m}`) }}</strong>
                                </v-subheader>
                                <template v-for="item in items">
                                    <v-list-item
                                        :key="item.idControlProgram"
                                        v-if="item.module === m"
                                        @click="selectProgram(item)"
                                    >
                                        <v-list-item-content>
                                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                                            <v-list-item-subtitle>{{ item.body }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-icon
                                                v-if="idControlProgram === item.idControlProgram"
                                                color="teal"
                                            >
                                                mdi-check-circle
                                            </v-icon>
                                        </v-list-item-action>
                                    </v-list-item>
                                </template>
                            </v-list>
                            <v-divider :key="`divider-${index}`"/>
                        </template>
                        <v-list dense>
                            <v-subheader>
                                <strong class="red--text">Validations</strong>
                            </v-subheader>
                            <v-list-item
                                v-if="totalRecruitmentRequestValidation > 0"
                                @click="goToValidation('recruitmentRequest')"
                            >
                                <v-list-item-content>
                                    <v-list-item-title>Demande Recrutement</v-list-item-title>
                                    <v-list-item-subtitle>{{ totalRecruitmentRequestValidation }} {{ $t('common.requests_need_validation') }}</v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-icon
                                        v-if="selectedModule === 'recruitmentRequest' && itemsToBeValidate"
                                        color="teal"
                                    >
                                        mdi-check-circle
                                    </v-icon>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item
                                v-if="totalAbsenceValidation > 0"
                                @click="goToValidation('absenceRequest')"
                            >
                                <v-list-item-content>
                                    <v-list-item-title>Demande d'Absence</v-list-item-title>
                                    <v-list-item-subtitle>{{ totalAbsenceValidation }} {{ $t('common.requests_need_validation') }}</v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-icon
                                        v-if="selectedModule === 'absenceRequest' && itemsToBeValidate"
                                        color="teal"
                                    >
                                        mdi-check-circle
                                    </v-icon>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item
                                v-if="totalVacationValidation > 0"
                                @click="goToValidation('vacation')"
                            >
                                <v-list-item-content>
                                    <v-list-item-title>Demande Congé</v-list-item-title>
                                    <v-list-item-subtitle>{{ totalVacationValidation }} {{ $t('common.requests_need_validation') }}</v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-icon
                                        v-if="selectedModule === 'vacation' && itemsToBeValidate"
                                        color="teal"
                                    >
                                        mdi-check-circle
                                    </v-icon>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item
                                v-if="totalClaimValidation > 0"
                                @click="goToValidation('claim')"
                            >
                                <v-list-item-content>
                                    <v-list-item-title>Réclamation</v-list-item-title>
                                    <v-list-item-subtitle>{{ totalClaimValidation }} {{ $t('common.requests_need_validation') }}</v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-icon
                                        v-if="selectedModule === 'claim' && itemsToBeValidate"
                                        color="teal"
                                    >
                                        mdi-check-circle
                                    </v-icon>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item
                                v-if="totalAdminRequestValidation > 0"
                                @click="goToValidation('adminRequest')"
                            >
                                <v-list-item-content>
                                    <v-list-item-title>Demande Administrative</v-list-item-title>
                                    <v-list-item-subtitle>{{ totalAdminRequestValidation }} {{ $t('common.requests_need_validation') }}</v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-icon
                                        v-if="selectedModule === 'adminRequest' && itemsToBeValidate"
                                        color="teal"
                                    >
                                        mdi-check-circle
                                    </v-icon>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item
                                v-if="totalDebtValidation > 0"
                                @click="goToValidation('debt')"
                            >
                                <v-list-item-content>
                                    <v-list-item-title>Gestion Prêt</v-list-item-title>
                                    <v-list-item-subtitle>{{ totalDebtValidation }} {{ $t('common.requests_need_validation') }}</v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-icon
                                        v-if="selectedModule === 'debt' && itemsToBeValidate"
                                        color="teal"
                                    >
                                        mdi-check-circle
                                    </v-icon>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item
                                v-if="totalPayDayAdvanceValidation > 0"
                                @click="goToValidation('payDayAdvance')"
                            >
                                <v-list-item-content>
                                    <v-list-item-title>Avance sur Salaire</v-list-item-title>
                                    <v-list-item-subtitle>{{ totalPayDayAdvanceValidation }} {{ $t('common.requests_need_validation') }}</v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-icon
                                        v-if="selectedModule === 'payDayAdvance' && itemsToBeValidate"
                                        color="teal"
                                    >
                                        mdi-check-circle
                                    </v-icon>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item
                                v-if="totalTrainingRequestValidation > 0"
                                @click="goToValidation('trainingRequest')"
                            >
                                <v-list-item-content>
                                    <v-list-item-title>Demande Formation</v-list-item-title>
                                    <v-list-item-subtitle>{{ totalTrainingRequestValidation }} {{ $t('common.requests_need_validation') }}</v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-icon
                                        v-if="selectedModule === 'trainingRequest' && itemsToBeValidate"
                                        color="teal"
                                    >
                                        mdi-check-circle
                                    </v-icon>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item
                                v-if="totalPaySlipAnnexValidation > 0"
                                @click="goToValidation('paySlipAnnex')"
                            >
                                <v-list-item-content>
                                    <v-list-item-title>Paie</v-list-item-title>
                                    <v-list-item-subtitle>{{ totalPaySlipAnnexValidation }} {{ $t('common.requests_need_validation') }}</v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-icon
                                        v-if="selectedModule === 'paySlipAnnex' && itemsToBeValidate"
                                        color="teal"
                                    >
                                        mdi-check-circle
                                    </v-icon>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-menu>
    </div>
</template>

<style scoped>

</style>